import { useDocumentTitle } from "~src/hooks/useDocumentTitle"
import { SafeArea } from "antd-mobile"
import React, { FC, useCallback } from "react"
import styles from "./index.module.less"
import { useNavigate } from "react-router-dom"
import { rank_list_btn_icon } from "~src/assets/images/urbanCarbonSecrets"
import { useWXPath } from "~src/hooks/useWXPath"


const CityCarbon: FC = () => {
  useDocumentTitle('城市碳秘')
  const navigate = useNavigate()
  const wxPath = useWXPath()

  const onJumpRule = () => {
    window.location.href = 'https://go-api.miotech.com/api/mp2c/duiba/h5?activityId=chengshitanmihuodongguizeyemian&cid=1231'
  }
  const onJumpRank = () => {
    navigate(`/urban_carbon_secrets/rank`)
  }
  const onViewPublished = () => {
    window.location.href = 'https://go-api.miotech.com/api/mp2c/duiba/h5?activityId=chenshitanmianlicankao&cid=1218'
  }

  // 去发布
  const goPublish = useCallback(() => {
    wxPath("redirectTo", "/pages/community/post/index")
  }, [wxPath])

  return <div className={styles.wrap}>
    <div className={styles.content}>
      <img className={styles.bg} src="https://resources-cn.miotech.com/static/mp2c/images/activity/urban-carbon-secrets/home_bg.png" alt="" />
      <div className={styles.ruleBtn} onClick={onJumpRule}>活动规则</div>
      <img className={styles.rankBtn} src={rank_list_btn_icon} onClick={onJumpRank} alt="" />
      <SafeArea position='bottom' />
      <div className={styles.footer}>
        <div className={styles.btns}>
          <div className={styles['btns-published']} onClick={onViewPublished}>查看发布案例</div>
          <div className={styles['btns-publish']} onClick={goPublish}>去发布</div>
        </div>
        <SafeArea position='bottom' />
      </div>


    </div>
  </div>
}
export default CityCarbon